import React from 'react'
import { NewsItem, Language } from '../../types'
import { t } from '../../i18n'

interface RelatedNewsProps {
  news: NewsItem[]
  lang: Language
  onNewsClick: (id: string) => void
}

export const RelatedNews: React.FC<RelatedNewsProps> = ({
  news,
  lang,
  onNewsClick,
}) => {
  if (news.length === 0) return null

  return (
    <div className='mt-12 mb-8'>
      <h3 className='text-sm font-black text-slate-900 uppercase tracking-widest mb-6 flex items-center gap-2'>
        {/* <span className='w-1 h-4 bg-rose-500 rounded-full'></span>
        {t(lang, 'relatedNews')} */}
      </h3>
      <div className='grid grid-cols-1 gap-2'>
        {news.map((item) => (
          <div
            key={item.id}
            onClick={() => onNewsClick(item.id)}
            className='group cursor-pointer bg-gray-50/50 rounded-2xl p-2 border border-gray-100'
          >
            <div className='flex gap-4'>
              {item.image && (
                <div className='w-14 h-14 shrink-0 rounded-xl overflow-hidden border border-gray-100 bg-white'>
                  <img
                    src={item.image}
                    alt=''
                    className='w-full h-full object-cover'
                  />
                </div>
              )}
              <div className='flex-1 min-w-0 flex flex-col justify-center'>
                <span className='text-[10px] font-black text-rose-500 uppercase tracking-tighter mb-1'>
                  {item.time}
                </span>
                <h4 className='text-xs md:text-sm font-bold text-slate-800 line-clamp-2 leading-snug group-hover:text-rose-500 transition-colors'>
                  {item.title}
                </h4>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
